/* NIVIA MAISON — player dos mini-vídeos (reels).

   Sem app e sem biblioteca: um modal só na página, criado na primeira
   vez que alguém clica. Botões de pausa e som, como na referência.

   As miniaturas tocam mudas em loop (viram capa animada); ao clicar,
   o vídeo abre grande e COM som. */
(function () {
  if (window.nmReelsReady) return;
  window.nmReelsReady = true;

  var modal = null;
  var video = null;
  var btnPlay = null;
  var btnSound = null;

  var ICON = {
    play: '<path d="M8 5v14l11-7z"/>',
    pause: '<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>',
    sound: '<path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    muted: '<path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="m16 9 5 6M21 9l-5 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
  };

  function svg(paths) {
    return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' + paths + '</svg>';
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'nm-reels-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="nm-reels-modal__content">' +
        '<div class="nm-reels-modal__controls">' +
          '<button type="button" class="nm-reels-modal__btn" data-nm-play aria-label="Pause">' + svg(ICON.pause) + '</button>' +
          '<button type="button" class="nm-reels-modal__btn" data-nm-sound aria-label="Mute">' + svg(ICON.sound) + '</button>' +
          '<button type="button" class="nm-reels-modal__btn" data-nm-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<video class="nm-reels-modal__video" playsinline controlslist="nodownload"></video>' +
      '</div>';
    document.body.appendChild(modal);

    video = modal.querySelector('video');
    btnPlay = modal.querySelector('[data-nm-play]');
    btnSound = modal.querySelector('[data-nm-sound]');

    btnPlay.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    video.addEventListener('play', function () { btnPlay.innerHTML = svg(ICON.pause); btnPlay.setAttribute('aria-label', 'Pause'); });
    video.addEventListener('pause', function () { btnPlay.innerHTML = svg(ICON.play); btnPlay.setAttribute('aria-label', 'Play'); });

    btnSound.addEventListener('click', function () {
      video.muted = !video.muted;
      btnSound.innerHTML = svg(video.muted ? ICON.muted : ICON.sound);
      btnSound.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    });

    modal.querySelector('[data-nm-close]').addEventListener('click', close);
    /* clicar no fundo fecha; clicar no vídeo, não */
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function open(src) {
    if (!modal) build();
    video.src = src;
    video.muted = false;
    video.currentTime = 0;
    btnSound.innerHTML = svg(ICON.sound);
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var p = video.play();
    /* Se o navegador bloquear autoplay com som, cai para mudo em vez de
       deixar a tela parada. */
    if (p && p.catch) {
      p.catch(function () {
        video.muted = true;
        btnSound.innerHTML = svg(ICON.muted);
        video.play();
      });
    }
  }

  function close() {
    if (!modal) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-nm-reel]');
    if (!thumb) return;
    var src = thumb.getAttribute('data-nm-reel');
    if (src) { e.preventDefault(); open(src); }
  });

  /* Miniaturas tocam mudas em loop só quando visíveis — economiza dados
     e evita 12 vídeos rodando ao mesmo tempo. */
  function autoplayThumbs() {
    var vids = document.querySelectorAll('.nm-reels__video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (typeof v.play !== 'function') return;
        if (en.isIntersecting) {
          v.muted = true; v.loop = true;
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState !== 'loading') autoplayThumbs();
  else document.addEventListener('DOMContentLoaded', autoplayThumbs);
})();
